import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { BuyBoxSection } from '../components/BuyBoxSection';
import { BonusesSection } from '../components/BonusesSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { FAQSection } from '../components/FAQSection';
import { StickyFooter } from '../components/StickyFooter';
export function LandingPage() {
  return <main className="min-h-screen bg-white" data-id="element-162">
      <HeroSection data-id="element-163" />
      <PainPointsSection data-id="element-164" />
      <WhatsInsideSection data-id="element-165" />
      <BenefitsSection data-id="element-166" />
      <BuyBoxSection data-id="element-167" />
      <BonusesSection data-id="element-168" />
      <ReviewsSection data-id="element-169" />
      <FAQSection data-id="element-170" />

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 px-4 text-center" data-id="element-171">
        <div className="max-w-4xl mx-auto" data-id="element-172">
          <p className="font-bold text-lg mb-3" data-id="element-173">MegaKit Lectura Feliz</p>
          <p className="text-gray-400 text-sm mb-6" data-id="element-174">
            Ayudando a miles de niños a descubrir el amor por la lectura.
          </p>
          <div className="text-xs text-gray-600" data-id="element-175">
            &copy; {new Date().getFullYear()} MegaKit Lectura Feliz. Todos los
            derechos reservados.
            <div className="mt-2 space-x-4" data-id="element-176">
              <a href="#" className="hover:text-white transition" data-id="element-177">
                Términos
              </a>
              <a href="#" className="hover:text-white transition" data-id="element-178">
                Privacidad
              </a>
              <a href="#" className="hover:text-white transition" data-id="element-179">
                Contacto
              </a>
            </div>
          </div>
        </div>
      </footer>

      <StickyFooter data-id="element-180" />
    </main>;
}